// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1GLqR","footer":"ModalCreateQualiphyProcedure_footer__i8KcY","additionData":"ModalCreateQualiphyProcedure_additionData__1d-Mn"};